/* eslint-disable @typescript-eslint/camelcase */
import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import { hot } from 'react-hot-loader'
import Masthead from '@ta-interaktiv/react-masthead'
import { Selector } from 'components/selector'
import { LoadingIndicator } from 'components/loadingIndicator'
import { ErrorBoundary } from 'components/errorBoundary'
import { Map } from 'components/map'
import { MotionScale as Scale } from 'components/scale'
import Popup from 'components/popup'
import MunicipalityDetail from 'components/municipalityDetail'
import InteractionCapabilities from 'components/interactionCapabilities'
import { List } from 'components/list'
import { Footer } from '@ta-interaktiv/react-footer'
import ThemeSwitch from '@ta-interaktiv/react-theme-switch'
import { MDXProvider } from '@mdx-js/react'
import { MunicipalitySearch } from 'components/municipalitySearch'
import { LocaleContext } from 'contexts/locale'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { Waypoint } from 'react-waypoint'

import styles from './styles.module.scss'

const ARTICLE_ID = '29738160'

const howToComponents = {
  h1: props => <h3 className={styles.textHeader} {...props} />,
  h3: props => <h3 className={styles.textHeader} {...props} />
}

const AppComponent = () => {
  const [locale, setLocale] = useState<'de' | 'fr'>('fr')

  // Download information on the locale to be used here
  useEffect(() => {
    fetch(`https://m.${parseHostname().publicationDomain}/api/sites/default`)
      .then(res => {
        if (res.ok) {
          return res.json()
        }
      })
      .then(data => {
        setLocale(data.site.language)
      })
  }, [])

  // Load messages
  const messages = require('./locales/' + locale + '.yml')
  const Intro = require(`text/${locale}/intro.mdx`).default
  const Analysis = require(`text/${locale}/analysis.mdx`).default
  const HowToRead = require(`text/${locale}/how-to-read.mdx`).default

  return (
    <LocaleContext.Provider value={locale}>
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} locale={locale} />
        <InteractionCapabilities />
        <ThemeSwitch />
        <header className='ui vertical fitted segment'>
          <div className='ui container'>
            <h1 className='ui header' style={{ marginBottom: 0 }}>
              {messages['title']}
            </h1>
            <h2 className='ui header' style={{ marginTop: 0 }}>
              <div className='sub header'>{messages['lead']}</div>
            </h2>
            <p className='ta author'>{messages['byline']}</p>
          </div>
        </header>

        <main className='ui vertical fitted segment'>
          <div className='ui text container'>
            <Intro />

            <div className='ui grey infographic segment'>
              <MDXProvider components={howToComponents}>
                <HowToRead />
              </MDXProvider>
            </div>
          </div>
        </main>

        <aside
          className='ui vertical green segment switzerland-map'
          // onMouseOver={event => this.props.mouseOverHandler(-1, event)}
        >
          <div className='ui container'>
            <h3 className='ui infographic header'>{messages['boxheader']}</h3>
            <Selector />
            <Scale />
          </div>

          <div style={{ position: 'relative' }}>
            <LoadingIndicator />

            <div className='ui container' style={{ marginTop: '1rem' }}>
              <MunicipalitySearch />
            </div>

            <ErrorBoundary>
              <div className='' style={{ overflow: 'hidden' }}>
                <Map />
              </div>
            </ErrorBoundary>
          </div>

          <div className='ui text container'>
            <List />
          </div>
        </aside>

        <Waypoint
          scrollableAncestor={window}
          onEnter={props => {
            if (props.previousPosition === Waypoint.below) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: '33ContentRead'
              })
            }
          }}
        />

        <Popup>
          <MunicipalityDetail />
        </Popup>

        <Footer
          hidePortfolioTeaser
          locale={locale}
          credits={messages['credits']}
          articleId={ARTICLE_ID}
          questions={messages['questions']}
        />
      </div>
    </LocaleContext.Provider>
  )
}

export default hot(module)(AppComponent)
